import React from 'react';
import { Settings } from 'lucide-react';
import { Card, CardContent } from '../../../../components/ui/card';
import { Input } from '../../../../components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../../../components/ui/select';

interface GeneralSettingsProps {
  companyName: string;
  timeZone: string;
  unit: string;
  onCompanyNameChange: (value: string) => void;
  onTimeZoneChange: (value: string) => void;
  onUnitChange: (value: string) => void;
}

export const GeneralSettings: React.FC<GeneralSettingsProps> = ({
  companyName,
  timeZone,
  unit,
  onCompanyNameChange,
  onTimeZoneChange,
  onUnitChange
}) => {
  return (
    <div className="space-y-4">
      <h2 className="text-lg font-semibold flex items-center gap-2">
        <Settings className="h-5 w-5 text-[#e04530]" />
        General Settings
      </h2>
      <Card className="border border-gray-200 bg-white">
        <CardContent className="p-6 space-y-4">
          <div className="grid grid-cols-3 gap-4">
            <div>
              <label className="text-sm font-medium mb-1.5 block">Company Name</label>
              <Input 
                placeholder="Enter company name" 
                className="bg-white"
                value={companyName}
                onChange={(e) => onCompanyNameChange(e.target.value)}
              />
            </div>
            <div>
              <label className="text-sm font-medium mb-1.5 block">Default Time Zone</label>
              <Select value={timeZone} onValueChange={onTimeZoneChange}>
                <SelectTrigger className="bg-white">
                  <SelectValue placeholder="Select time zone" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="utc">UTC</SelectItem>
                  <SelectItem value="est">Eastern Time</SelectItem>
                  <SelectItem value="pst">Pacific Time</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <div>
              <label className="text-sm font-medium mb-1.5 block">Default Unit</label>
              <Select value={timeZone} onValueChange={onTimeZoneChange}>
                <SelectTrigger className="bg-white">
                  <SelectValue placeholder="Select time zone" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="utc">Metric</SelectItem>
                  <SelectItem value="est">Imperial</SelectItem>
                </SelectContent>
              </Select>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}; 